import { object, string, number } from "yup";

export const filtersSchema = object({
  customername: string()
    .required("Müşteri adı zorunludur")
    .min(3, "Müşteri adı 3 karakterden kısa olamaz")
    .max(150, "Cari Hesap Kodu 150 karakterden uzun olamaz"),
  customercode: string()
    .max(50, "Cari Hesap Ünvanı 50 karakterden uzun olamaz"),
  tcnvkn: string()
    .required("VKN/TCKN giriniz.")
    .min(10, "VKN/TCKN 10 karakterden kısa olamaz")
    .max(11, "VKN/TCKN 11 karakterden uzun olamaz"),
  email: string()
    .max(100, "E-Posta adresi 100 karakterden uzun olamaz.")
    .email("Lütfen Email adresini doğru formatta giriniz")
    .when("sendtypeid", {
      is: 2,
      then: string().required("Geçerli bir eposta adresi giriniz"),
    })
    .when("sendtypeid", {
      is: 3, // tumu
      then: string().required("Geçerli bir eposta adresi giriniz"),
    }),
  // .required("Geçerli bir eposta adresi giriniz"),
  phone: string()
    .when("sendtypeid", {
      is: 1, // sms
      then: string()
        .required("Telefon numarası giriniz")
        .matches(
          /^(\d{10}|[.\(\/]?5[0-9]{2}[.\)\/]?[.\ \/][0-9][0-9]{2}[.\ \/]?[0-9]{2}[.\ \/]?[0-9]{2})$/,
          "Lütfen telefon numarasını doğru formatta giriniz"
        ),
    })
    .when("sendtypeid", {
      is: 3, // email+sms
      then: string()
        .required("Telefon numarası giriniz")
        .matches(
          /^(\d{10}|[.\(\/]?5[0-9]{2}[.\)\/]?[.\ \/][0-9][0-9]{2}[.\ \/]?[0-9]{2}[.\ \/]?[0-9]{2})$/,
          "Lütfen telefon numarasını doğru formatta giriniz"
        ),
    })
    .when("sendtypeid", {
      is: 5, // whatsapp
      then: string()
        .required("Telefon numarası giriniz")
        .matches(
          /^(\d{10}|[.\(\/]?5[0-9]{2}[.\)\/]?[.\ \/][0-9][0-9]{2}[.\ \/]?[0-9]{2}[.\ \/]?[0-9]{2})$/,
          "Lütfen telefon numarasını doğru formatta giriniz"
        ),
    }),
    
  sendtypeid: number().required("Gonderim tipi secmek zorunludur"),
  amount: string()
    .required("0 TL'den büyük bir tutar giriniz")
    .matches(
      /(?!0\.00)^\d{1,3}(?:,\d{3})*\.\d*$/,
      "0 TL'den büyük bir tutar giriniz"
    ),
  linkdesc: string()
    .max(100, "Açıklama en fazla 100 karakter içermelidir.")
});
